module.exports = __webpack_public_path__ + "img/high-speed-train.0c4fbf1c.png";